<template>
      <keep-alive :include="list">
            <router-view></router-view>
          </keep-alive>
</template>
<script>
  import {mapGetters} from 'vuex'

export default {
  computed: {
      ...mapGetters(['tagList']),
    list(){
      return this.tagList.map(item=>item.name)
    }
  },
}
</script>
